import { api_GET, api_POST } from "./_api.js";
// import { getSessionCookie } from "../helpers/cookies.js";

const confirmacaoInfrator_api = {
    GetConfirmacaoInfratores: (tipoFiscalicao_id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ConfirmacaoInfrator/GetConfirmacaoInfratores/${tipoFiscalicao_id}`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    PostOrUpdateInfrator: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("ConfirmacaoInfrator/PostInfrator", json).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    }
}

export default confirmacaoInfrator_api;